import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Wizard } from '@bingads-webui-fluent-component/wizard';
import { WizardPerfMarker } from '@bingads-webui-campaign/wizard-performance-marker';
import { PerformanceMarkerProvider } from '@bingads-webui-campaign-react/performance-marker-provider';
import { Scenario, Activity } from '@bingads-webui-react/hoc-with-signal';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

import { LinkedInSingleStepConfigs } from './steps/step-config';
import { SingleStepLayoutContainer } from './wizard-components/single-step-layout-container';

const SINGLE_STEP_ID = 'SINGLE_STEP_ID';

export const LinkedInBaseSingleStepWizard = ({
  scenario, perfMarker, onDone, onExited,
}) => {
  const instrumentation = useContext(InstrumentationContext);
  const wizardPerfMarker = useMemo(() => perfMarker.createChild(scenario), [perfMarker, scenario]);

  const config = useMemo(() => ({
    id: scenario,
    steps: [{ id: SINGLE_STEP_ID, ...LinkedInSingleStepConfigs[scenario] }],
    actions: { onDone, onExited },
  }), [onDone, onExited, scenario]);

  return (
    <PerformanceMarkerProvider
      name={scenario}
      instrumentation={instrumentation}
      immediateDone={false}
    >
      <Scenario name={scenario}>
        <Activity name="DefaultWizardActivity">
          <Wizard config={config}>
            <WizardPerfMarker wizardName={scenario} wizardMarker={wizardPerfMarker}>
              <SingleStepLayoutContainer />
            </WizardPerfMarker>
          </Wizard>
        </Activity>
      </Scenario>
    </PerformanceMarkerProvider>
  );
};

LinkedInBaseSingleStepWizard.propTypes = {
  scenario: PropTypes.string.isRequired,
  perfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  onDone: PropTypes.func.isRequired,
  onExited: PropTypes.func.isRequired,
};
